import PropTypes from 'prop-types';
import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import Panel from '../../../Panels';
import Attribute from '../Attribute';
import { SocialMediaScreeningsObject } from '../../../../types/report';

interface SocialMediaScreeningsProps {
  search: SocialMediaScreeningsObject | null | undefined;
}

const SocialMediaScreenings = ({
  search,
}: SocialMediaScreeningsProps): React.ReactElement | null => {
  if (!search || search.status === 'canceled') return null;

  const displayStatus = search.status;

  return (
    <Panel
      title={i18n.getStr('components.socialMediaScreenings.title')}
      status={displayStatus}
    >
      <Attribute
        attr={i18n.getStr('components.socialMediaScreenings.flaggedBehaviors')}
        value={i18n.getStr(
          'components.socialMediaScreenings.reportDownloadHint',
        )}
      />
    </Panel>
  );
};

SocialMediaScreenings.propTypes = {
  search: PropTypes.object,
};

SocialMediaScreenings.defaultProps = {
  search: null,
};

export default i18n.renderTranslation()(SocialMediaScreenings);
